module.exports = __webpack_public_path__ + "img/MenyStor.888985de.jpg";